import { render, staticRenderFns } from "./ImprestAttachmentPreview.vue?vue&type=template&id=6a380be7"
import script from "./ImprestAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./ImprestAttachmentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports